
// const AmplifyConfig=({
//   Auth: {
//     Cognito:{
//       region: process.env.REACT_APP_COGNITO_REGION, 
//       userPoolId: process.env.REACT_APP_USER_POOL_ID,
//       userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID, 
//       identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID, 
//       loginWith:{
//         email: true,
        
//     }
//     }
//   },
//   Storage:{
//     S3:{
//       bucket:process.env.REACT_APP_BUCKET_NAME,
//       region: process.env.REACT_APP_BUCKET_REGION,
//     }
//   }
// });


// export default AmplifyConfig;
const AmplifyConfig=({
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      loginWith: {
        email: true
      }
    }
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_BUCKET_NAME,
      region: process.env.REACT_APP_BUCKET_REGION,
    
    }
  }
});

export default AmplifyConfig;